module.exports = __webpack_public_path__ + "media/images/new-black-logo-56a1ce70.png";